var _style, _path, _rect, _line, _line2, _line3, _line4, _line5, _line6, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoEchDe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 277.8 102",
    style: {
      enableBackground: "new 0 0 277.8 102"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:none;}\r\n\t.st2{fill:#12385F;}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.3857,
    y1: 71.5544,
    x2: 29.3331,
    y2: 47.5018
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA5B0C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7A823"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.6,76.5h1.4v-6h-1.4V76.5z M34.3,75l1.3,0.5l2.3-5.6l-1.3-0.5L34.3,75z M44.9,69.9l2.3,5.6l1.3-0.6l-2.3-5.6  L44.9,69.9z M28.8,71.1l1,1l4.3-4.3l-1-1L28.8,71.1z M48.6,67.8l4.3,4.3l1-1l-4.3-4.3L48.6,67.8z M25.4,65.4l0.6,1.3l5.6-2.3  L31,63.1L25.4,65.4z M51.3,64.3l5.6,2.3l0.5-1.3L51.8,63L51.3,64.3z M24.4,60.2h6v-1.4h-6V60.2z M52.3,60.2h6v-1.4h-6V60.2z   M25.3,53.7l5.6,2.3l0.5-1.3l-5.6-2.3L25.3,53.7z M51.2,54.6l0.6,1.3l5.6-2.3l-0.6-1.3L51.2,54.6z M28.8,48l4.3,4.3l1-1L29.8,47  L28.8,48z M48.6,51.3l1,1l4.3-4.3l-1-1L48.6,51.3z M34.1,44.1l2.3,5.6l1.3-0.6l-2.3-5.6L34.1,44.1z M44.9,49.1l1.3,0.5l2.3-5.6  l-1.3-0.5L44.9,49.1z M40.6,48.5h1.4v-6h-1.4V48.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st1",
    width: 277.8,
    height: 102
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 25.5,
    y1: 0,
    x2: 25.5,
    y2: 102
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 69.4,
    y1: 0,
    x2: 69.4,
    y2: 102
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 252.3,
    y1: 0,
    x2: 252.3,
    y2: 102
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 277.5,
    y1: 42.5,
    x2: -0.3,
    y2: 42.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 277.5,
    y1: 17,
    x2: -0.3,
    y2: 17
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 277.5,
    y1: 76.5,
    x2: -0.3,
    y2: 76.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M239.2,52.9h-1.1v13.2h1.1V52.9z M144.3,52.7h-2.7v13.4h2.7V52.7z M71.8,58.2c0.3-2.2,1.8-3.7,3.9-3.7  c2,0,3.5,1.4,3.6,3.7H71.8z M71.8,60.3h10.3v-0.9c0-4.5-2.6-6.9-6.4-6.9c-3.9,0-6.6,2.7-6.6,6.9c0,4.4,2.8,6.9,6.6,6.9  c3.1,0,5.6-1.5,6.2-4.4H79c-0.4,1.5-1.8,2.3-3.4,2.3C73.2,64.2,71.9,62.3,71.8,60.3 M94.2,66.1H97v-8.5c0-3.2-1.7-5.2-4.7-5.2  c-2.1,0-3.6,0.9-4.5,2.3v-2h-2.6v13.4h2.7v-7.4c0-2.2,1.2-4,3.5-4c1.8,0,2.9,0.9,2.9,3.6V66.1z M102.6,58.2c0.3-2.2,1.8-3.7,3.9-3.7  c2,0,3.5,1.4,3.6,3.7H102.6z M102.6,60.3h10.3v-0.9c0-4.5-2.6-6.9-6.4-6.9c-3.9,0-6.6,2.7-6.6,6.9c0,4.4,2.8,6.9,6.6,6.9  c3.1,0,5.6-1.5,6.2-4.4h-2.8c-0.4,1.5-1.8,2.3-3.4,2.3C104,64.2,102.7,62.3,102.6,60.3 M122.4,55.2c0.4,0,0.8,0,1.3,0v-2.7  c-0.4,0-0.6,0-0.7,0c-1.9,0-3.6,0.8-4.4,2.8v-2.6h-2.6v13.4h2.7v-7C118.6,56.6,120.2,55.2,122.4,55.2 M135.5,59.1  c0,2.5-1.3,4.4-3.8,4.4c-2.4,0-3.7-1.9-3.7-4.4c0-2.5,1.3-4.4,3.7-4.4C134.2,54.7,135.5,56.6,135.5,59.1 M138,65.3V52.7h-2.6v1.8  c-0.9-1.3-2.4-2.1-4.3-2.1c-3.2,0-6,2.4-6,6.7c0,4.2,2.9,6.6,6.1,6.6c1.7,0,3.1-0.7,4.1-1.9v1.7c0,2.6-1.6,3.5-3.7,3.5  c-2,0-3.2-0.7-3.4-2.1h-2.8c0.1,2.5,2.1,4.3,6.2,4.3C135.4,71.2,138,69.2,138,65.3 M141.6,50.4h2.8v-2.7h-2.8V50.4z M150.1,58.2  c0.3-2.2,1.8-3.7,3.9-3.7c2,0,3.5,1.4,3.6,3.7H150.1z M150.1,60.3h10.3v-0.9c0-4.5-2.6-6.9-6.4-6.9c-3.9,0-6.6,2.7-6.6,6.9  c0,4.4,2.8,6.9,6.6,6.9c3.1,0,5.6-1.5,6.2-4.4h-2.8c-0.4,1.5-1.8,2.3-3.4,2.3C151.5,64.2,150.2,62.3,150.1,60.3 M165.1,56.4  c0-1.6,1.4-2.6,3.5-2.6c2,0,3.4,0.9,3.6,2.7h1.2c-0.2-2.7-2.5-3.9-4.8-3.9c-2.7,0-4.7,1.5-4.7,3.7c0,1.9,1.2,2.9,3.4,3.3l2.8,0.6  c1.6,0.3,2.5,0.9,2.5,2.2c0,1.3-1.1,2.7-3.8,2.7c-2.8,0-3.9-1.4-4-2.8h-1.2c0.2,2.3,2.1,4,5.2,4c3.2,0,5-1.7,5-3.8  c0-1.9-1.2-2.9-3.4-3.3l-2.8-0.6C166,58.3,165.1,57.7,165.1,56.4 M177.5,59.5c0-3.2,1.6-5.7,4.8-5.7c2,0,3.8,1.1,4.2,3.3h1.2  c-0.4-2.7-2.5-4.5-5.4-4.5c-3.4,0-6,2.6-6,6.8s2.6,6.8,6,6.8c2.9,0,5-1.8,5.4-4.5h-1.2c-0.3,2.2-2.1,3.3-4.2,3.3  C179.1,65.2,177.5,62.7,177.5,59.5 M200.2,66.1h1.1v-8c0-3.7-2.1-5.5-4.9-5.5c-2,0-3.6,1.1-4.3,2.6v-8H191v18.8h1.1v-7.8  c0-2.3,1.8-4.6,4.3-4.6c2.2,0,3.7,1.3,3.7,4.4V66.1z M217.4,66.1l3.9-13.2h-1.2l-3.4,11.9l-3.5-11.9h-1.5l-3.5,11.9l-3.4-11.9h-1.2  l4,13.2h1.4l3.5-11.9l3.6,11.9H217.4z M233.5,58.8h-9.1c0.3-3.3,2.2-5,4.7-5C231.6,53.8,233.4,55.5,233.5,58.8 M234.7,59.8  c0-0.2,0-0.3,0-0.5c0-4.7-2.7-6.7-5.6-6.7c-3.4,0-5.9,2.6-5.9,6.8c0,4.3,2.6,6.9,5.9,6.9c2.5,0,4.8-1.3,5.3-4.1h-1.2  c-0.6,2.1-2.2,2.9-4.2,2.9c-2.9,0-4.6-2.4-4.6-5.3H234.7z M238.1,50.1h1.1v-1.8h-1.1V50.1z M252.3,53.9v-1h-9.7V54h8.3l-8.6,11.1v1  h9.8V65h-8.4L252.3,53.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.2,17.9v7.6h-0.7v-8.3h1.1l3.1,7.6l3.1-7.6h1.1v8.3h-0.7v-7.6l-3.1,7.6h-0.8L70.2,17.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M79.9,17.5h0.9v0.9h-0.9V17.5z M80.7,19.6v5.9H80v-5.9H80.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82,19.6h1V18h0.6v1.6h1.7v0.6h-1.7v3.6c0,0.7,0.3,1.1,0.9,1.1c0.3,0,0.5,0,0.8-0.1v0.6   c-0.3,0.1-0.6,0.1-0.9,0.1c-0.9,0-1.5-0.6-1.5-1.6v-3.7h-1V19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M89.3,22.3v-5.2H90v5.2c0,1.6,1,2.6,2.5,2.6c1.5,0,2.5-1,2.5-2.6v-5.2h0.7v5.2c0,2.2-1.4,3.2-3.2,3.2   C90.7,25.6,89.3,24.5,89.3,22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M97.6,25.4v-5.9h0.6v1c0.4-0.7,1.1-1.1,1.9-1.1c1.3,0,2.1,0.8,2.1,2.4v3.6h-0.6v-3.5c0-1.3-0.6-1.8-1.6-1.8   c-1.1,0-1.8,1-1.8,2v3.4H97.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103.5,19.6h1V18h0.6v1.6h1.7v0.6h-1.7v3.6c0,0.7,0.3,1.1,0.9,1.1c0.3,0,0.5,0,0.8-0.1v0.6   c-0.3,0.1-0.6,0.1-0.9,0.1c-0.9,0-1.5-0.6-1.5-1.6v-3.7h-1V19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M110.5,19.5c1.4,0,2.6,0.9,2.6,3c0,0.1,0,0.1,0,0.3h-4.5c0,1.2,0.7,2.2,2,2.2c0.8,0,1.5-0.4,1.8-1.2h0.7   c-0.2,1.3-1.3,1.8-2.4,1.8c-1.5,0-2.7-1.1-2.7-3C107.8,20.6,109,19.5,110.5,19.5z M112.4,22.1c0-1.4-0.8-2.1-1.9-2.1   c-1.1,0-1.9,0.7-2,2.1H112.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M117.6,20.2c-0.2,0-0.3,0-0.5,0c-0.9,0-1.8,0.8-1.8,2v3.3h-0.6v-5.9h0.6v1.1c0.3-0.9,1.2-1.2,1.9-1.2   c0.1,0,0.2,0,0.4,0V20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M120.8,19.5c1.1,0,2.1,0.5,2.2,1.7h-0.7c-0.1-0.7-0.7-1.1-1.5-1.1c-0.9,0-1.5,0.4-1.5,1.1c0,0.5,0.4,0.8,1,0.9   l1.2,0.2c1,0.2,1.5,0.7,1.5,1.5c0,1-0.8,1.7-2.3,1.7c-1.4,0-2.3-0.7-2.4-1.8h0.7c0,0.6,0.6,1.2,1.7,1.2s1.6-0.5,1.6-1.1   c0-0.5-0.4-0.8-1-0.9l-1.2-0.3c-1-0.2-1.5-0.7-1.5-1.5C118.6,20.2,119.6,19.5,120.8,19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M124,19.6h1V18h0.6v1.6h1.7v0.6h-1.7v3.6c0,0.7,0.3,1.1,0.9,1.1c0.3,0,0.5,0,0.8-0.1v0.6   c-0.3,0.1-0.6,0.1-0.9,0.1c-0.9,0-1.5-0.6-1.5-1.6v-3.7h-1V19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M133.4,19.6v5.9h-0.6v-1c-0.4,0.7-1,1.1-1.9,1.1c-1.3,0-2.1-0.9-2.1-2.4v-3.6h0.6v3.5c0,1.4,0.6,1.8,1.5,1.8   c1.1,0,1.8-1,1.8-2.1v-3.3H133.4z M129.5,17.5h0.9v0.9h-0.9V17.5z M131.7,17.5h0.9v0.9h-0.9V17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M134.7,19.6h1V18h0.6v1.6h1.7v0.6h-1.7v3.6c0,0.7,0.3,1.1,0.9,1.1c0.3,0,0.5,0,0.8-0.1v0.6   c-0.3,0.1-0.6,0.1-0.9,0.1c-0.9,0-1.5-0.6-1.5-1.6v-3.7h-1V19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M143.6,19.6v0.5l-3.7,4.7h3.6v0.6H139v-0.5l3.7-4.7h-3.6v-0.6H143.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M149.6,19.6v5.9H149v-1c-0.4,0.7-1,1.1-1.9,1.1c-1.3,0-2.1-0.9-2.1-2.4v-3.6h0.6v3.5c0,1.4,0.6,1.8,1.5,1.8   c1.1,0,1.8-1,1.8-2.1v-3.3H149.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M151.6,25.4v-5.9h0.6v1c0.4-0.7,1.1-1.1,1.9-1.1c1.3,0,2.1,0.8,2.1,2.4v3.6h-0.6v-3.5c0-1.3-0.6-1.8-1.6-1.8   c-1.1,0-1.8,1-1.8,2v3.4H151.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M163,25.3c0,1.5-1,2.3-2.5,2.3c-1.5,0-2.3-0.8-2.4-1.8h0.7c0.1,0.8,0.7,1.2,1.7,1.2c1,0,1.9-0.4,1.9-1.8v-1   c-0.4,0.6-1.1,1-1.9,1c-1.3,0-2.6-1-2.6-2.9c0-2,1.2-2.9,2.6-2.9c0.9,0,1.6,0.4,2,1.1v-1h0.6V25.3z M160.4,24.7   c1.3,0,1.9-1,1.9-2.3c0-1.3-0.7-2.3-1.9-2.3c-1.2,0-1.9,1-1.9,2.3C158.5,23.7,159.2,24.7,160.4,24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M171.4,19.6h0.7l-2.2,5.9h-0.7l-2.2-5.9h0.7l1.9,5.1L171.4,19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M172.9,22.5c0-1.9,1.1-3,2.7-3s2.7,1.2,2.7,3c0,1.8-1.2,3-2.7,3S172.9,24.4,172.9,22.5z M177.6,22.5   c0-1.4-0.7-2.4-2-2.4c-1.3,0-2,1-2,2.4c0,1.4,0.7,2.4,2,2.4C176.9,24.9,177.6,23.9,177.6,22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M179.9,25.4v-5.9h0.6v1c0.4-0.7,1.1-1.1,1.9-1.1c1.3,0,2.1,0.8,2.1,2.4v3.6H184v-3.5c0-1.3-0.6-1.8-1.6-1.8   c-1.1,0-1.8,1-1.8,2v3.4H179.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEchDe);
export default __webpack_public_path__ + "static/media/logo_ech_de.927a4ebef85feaecad0c9ba37ca67b00.svg";
export { ForwardRef as ReactComponent };